import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-recupero-crediti-stragiudiziale-view',
  templateUrl: './form-recupero-crediti-stragiudiziale-view.component.html',
  styleUrls: ['./form-recupero-crediti-stragiudiziale-view.component.css']
})
export class FormRecuperoCreditiStragiudizialeViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
